(function() {
    /* jshint validthis: true */
    "use strict";

    var lang = lang || document.documentElement.lang;
    
    function submitSlide(){
        var t = $(this);
        var ctn = t.closest(".add-a-slide");
        
        var id = ctn.find("input[name = 'id']").val();
        var field1 = ctn.find("input[name = 'field1']").val();
        var field2 = ctn.find("input[name = 'field2']").val();
        var field3 = ctn.find("input[name = 'field3']").val();
        var field4 = ctn.find("input[name = 'field4']").val();
        var field5 = ctn.find(".slider-image-selection").attr("data-preview-item-id");
        var active = ctn.find("input[name = 'active']").is(":checked");
        
        var data = new FormData();
        if(id !== ''){
            data.append('id', id);            
        }
        data.append('field1', field1);
        data.append('field2', field2);
        data.append('field3', field3);
        data.append('field4', field4);
        data.append('field5', field5);
        data.append('pageId', ctn.attr("data-pageId"));
        if(ctn.attr("data-slider").length !== 0) {
            data.append('sliderId', ctn.attr("data-slider"));
        }
        data.append('active', active);
        data.append('ajax', 'true');

        $.ajax({
            url: '/action/manageSlide',
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            data: data,
            success: function (response) {
                createNewSlide(id, field1, field2, field3, field4, field5, active, response);
                resetForm(ctn);
                offerToReloadPage();
//                console.log('slide created : ' + response);
            }
        });
    }
    
    function resetForm(ctn){
        ctn.find("input[name = 'id']").val("");
        ctn.find("input[type = 'text']").val("");
        ctn.find("input[type = 'text']").removeClass("filled");
        ctn.find("input[type = 'checkbox']").prop("checked", false);
        ctn.find(".slider-image-selection").attr("style", "");
        ctn.find(".slider-image-selection").attr("data-preview-item-id", "");
        
    }
    
    function createNewSlide(id, field1, field2, field3, field4, field5, active, response){
        var clone = $(".slide-elmt-model").clone(true);
        var newid = (id !== '') ? id : response.substring(0, response.indexOf("-"));
        clone.attr("data-id", newid);
        clone.find(".box-image").attr("style", "background-image: url('" + field5 + "')");
        clone.find(".slide-elmt-txt").append(field1);
        
        clone.removeClass("hide").removeClass("slide-elmt-model");
        
        var obj = JSON.parse(clone.find(".json-elmt").text().trim());
        obj.id = newid;
        obj.field1 = field1;
        obj.field2 = field2;
        obj.field3 = field3;
        obj.field4 = field4;
        obj.field5 = field5;
        obj.active = active;
        clone.find(".json-elmt").text(JSON.stringify(obj));
        
        if(active){
            clone.find(".active-slide-btn").addClass("active");
        }
        
        bindEvent(qsa(".active-slide-btn", clone[0]), "click", toggleActiveSlide);
        bindEvent(qsa(".delete-slide-btn", clone[0]), "click", delSlidePopup);
        bindEvent(qsa(".edit-slide-btn", clone[0]), "click", editSlide);
        
        if(id !== ''){
            $(".slide-elmt[data-id = '" + id + "']").replaceWith(clone);
        } else {
            $(".slides-list").append(clone);
        }
    }
    
    function toggleActiveSlide(){
        var t = $(this);
        var ctn = t.closest(".slide-elmt");
        var id = ctn.attr("data-id");
        
        var data = new FormData();
        data.append('id', id);
        data.append('action', "true");
        data.append('active', !t.hasClass("active"));
        data.append('ajax', 'true');

        $.ajax({
            url: '/action/manageSlide',
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            data: data,
            success: function (response) {
                updateJSON(id, "active", !t.hasClass("active"));
                offerToReloadPage();
                
                t.toggleClass("active");
            }
        });
        
    }
    
    var delId = "";
    function delSlidePopup(){
        var t = $(this);
        var ctn = t.closest(".slide-elmt");
        var id = ctn.attr("data-id");
        
        delId = id;
        openWindow("deleteSlidePopup", true);
    }
    
    function delSlideCancel(){        
        delId = "";
        closeWindow("deleteSlidePopup");
    }
    
    function delSlideConfirm(){  
        var data = new FormData();
        data.append('id', delId);
        data.append('delete', "true");
        data.append('ajax', 'true');

        $.ajax({
            url: '/action/manageSlide',
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            data: data,
            success: function (response) {
                offerToReloadPage();
                $(".slide-elmt[data-id = '" + delId + "']").remove();
                delId = "";
                closeWindow("deleteSlidePopup");
            }
        });
    }
    
    function toggleSlideForm(){
        var t = $(this);
        $(".add-a-slide").slideToggle(function(){
            t.toggleClass("opened");
        });
    }
    
    function offerToReloadPage(){
        $(".slider-reload-page").fadeIn();
    }
    
    function initSortable() {
        $(".slides-list").sortable({
            handle: ".drag-slide-handle",
            revert: 160,
            tolerance: "pointer",
            scrollSensitivity: 60,
            scrollSpeed: 30,
            update: function (e, ui) {
                var index = ui.item.index();
                var id = $(ui.item).attr("data-id");

                var url = "/action/manageSlide";

                var data = new FormData();
                data.append("id", id);
                data.append("targetPosition", index);
                data.append("ajax", "true");

                $.ajax({
                    url: url,
                    data: data,
                    cache: false,
                    contentType: false,
                    processData: false,
                    type: 'POST',
                    success: function (response) {
                        offerToReloadPage();
                    }
                });
            }
        });   
    }
    
    function editSlide(){
        var t = $(this);
        var obj = JSON.parse(t.find(".json-elmt").text().trim());

        var id = obj.id;
        var active = obj.active;
        var field1 = obj.field1; //main text
        var field2 = obj.field2; //second text
        var field3 = obj.field3; //button text
        var field4 = obj.field4; //button url
        var field5 = obj.field5; //image path

        if (!$(".add-slider-slide").hasClass("opened")) {
            $(".add-slider-slide")[0].click();
        }
        $(".cancel-slider-edit-btn").removeClass("hide");
        
        var form = $(".add-a-slide");
        addValue(form, id, "id");
        addValue(form, field1, "field1");
        addValue(form, field2, "field2");
        addValue(form, field3, "field3");
        addValue(form, field4, "field4");
        addValue(form, field5, "field5");
        addCheckValue(form, active === 'true', "active");
        
        form.find(".slider-image-selection").css("background-image", "url('" + field5 + "')");
        form.find(".slider-image-selection").attr("data-preview-item-id", field5 );
        form.closest(".stool-shared-popup-content-ctn").animate({
            scrollTop: 0
        }, 400);
                
    }
    
    function addValue(form, elmt, name){
        if(elmt !== ''){
            form.find("input[name = '" + name + "']").val(elmt);
            form.find("input[name = '" + name + "']").addClass("filled");
        } else {
            form.find("input[name = '" + name + "']").val("");
            form.find("input[name = '" + name + "']").removeClass("filled");
        }
    }
    
    function addCheckValue(form, elmt, name){
        form.find("input[name = '" + name + "']").attr("checked", elmt);
    }
    
    function updateJSON(id, name, value){
        var ctn = $(".slide-elmt[data-id = '" + id + "']").find(".json-elmt");
        var obj = JSON.parse(ctn.text().trim());
        
        obj[name] = value.toString();
        
        ctn.text(JSON.stringify(obj));
    }
    
    function editSlideCancel(){
        var t = $(this);
        var ctn = t.closest(".add-a-slide");
        resetForm(ctn);        
    }
    
    // Pre-initiate
    DOMInit("interactive", function(e) {
        if ($(".slider-home").length !== 0) {
            initSlick($(".slider-home"), {});
        }        
    });
    
    // Initiate
    DOMInit("complete", function(e) {
        
        bindEvent(".add-slider-slide", "click", toggleSlideForm);
        bindEvent(".add-slider-slide-btn", "click", submitSlide);
        
        //Slides actions
        bindEvent(".active-slide-btn", "click", toggleActiveSlide);
        bindEvent(".delete-slide-btn", "click", delSlidePopup);
        bindEvent(".delete-slide-btn-cancel", "click", delSlideCancel);
        bindEvent(".delete-slide-btn-confirm", "click", delSlideConfirm);
        bindEvent(".edit-slide-btn", "click", editSlide);
        bindEvent(".cancel-slider-edit-btn", "click", editSlideCancel);
        
        initSortable();
    });

})();